import React, { useState } from 'react';
import Header from './components/Header';
import SignDetector from './components/SignDetector';
import ResultPanel from './components/ResultPanel';
import SignDictionary from './components/SignDictionary';
import './App.css';

function App() {
  const [detectedSign, setDetectedSign] = useState(null);
  const [sentence, setSentence] = useState([]);
  const [activeTab, setActiveTab] = useState('detect');

  const handleSignDetected = (sign) => {
    setDetectedSign(sign);
  };

  const handleAddToSentence = (letter) => {
    setSentence(prev => [...prev, letter]);
  };

  const handleClearSentence = () => setSentence([]);

  return (
    <div className="app">
      <Header />
      <nav className="tab-nav">
        <button
          className={`tab-btn ${activeTab === 'detect' ? 'active' : ''}`}
          onClick={() => setActiveTab('detect')}
        >
          <span className="tab-icon">📷</span> Live Detection
        </button>
        <button
          className={`tab-btn ${activeTab === 'dictionary' ? 'active' : ''}`}
          onClick={() => setActiveTab('dictionary')}
        >
          <span className="tab-icon">📚</span> Sign Dictionary
        </button>
      </nav>

      {activeTab === 'detect' ? (
        <main className="main-layout">
          <div className="detector-col">
            <SignDetector
              onSignDetected={handleSignDetected}
              onAddToSentence={handleAddToSentence}
            />
          </div>
          <div className="result-col">
            <ResultPanel
              detectedSign={detectedSign}
              sentence={sentence}
              onClearSentence={handleClearSentence}
              onAddToSentence={handleAddToSentence}
            />
          </div>
        </main>
      ) : (
        <SignDictionary />
      )}
    </div>
  );
}

export default App;
